import {
    GET_LIST_QUESTION,
    GET_ALL_QUESTION,
    GET_MORE_ANSWERED_QUESTION,
    GET_MORE_ANSWERS,
    UPDATE_LIKES,
    SET_COMMUNITY_KEY,
    GET_HELPSECTION_DATA
} from "../actions/CommunityAction";

const initialState = {
    listQuestions: {},
    moreAnsweredQuestion: {},
    moreAnswers: {
        data: {
            question: {},
            response: [],
        },
        actualPage: 0,
        nextPage: 0,
        totalPerPage: 0,
        totalItems: 0,
        totalPages: 0
    },
    keyValue: '',
    helpData: {},
}

const communityReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_HELPSECTION_DATA:
            return {
                ...state,
                helpData: action.data
            }
        case SET_COMMUNITY_KEY:
            return {
                ...state,
                keyValue: action.data
            }
        case GET_LIST_QUESTION:
            return {
                ...state,
                listQuestions: action.data
            }
        case GET_ALL_QUESTION:
            return {
                ...state,
                listQuestions: action.data
            }
        case GET_MORE_ANSWERED_QUESTION:
            return {
                ...state,
                moreAnsweredQuestion: action.data
            }
        case GET_MORE_ANSWERS:
            return {
                ...state,
                moreAnswers: action.data
            }
        case UPDATE_LIKES:
            return {
                ...state,
                moreAnswers: {
                    ...state.moreAnswers,
                    data: {
                        ...state.moreAnswers.data,
                        response: action.data,
                        // lawyerUsers: {
                        //     ...state.moreAnswers.data.lawyerUsers,
                        //     gotLikes: action.data.newGotLikes
                        // }
                    }
                }
            }
        default:
            return state
    }
}

export default communityReducer;